/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Req_TitleInputs */

const en_pc_dl_req_title = /** @type {(inputs: Pc_Dl_Req_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`System requirements`)
};

const zh_pc_dl_req_title = /** @type {(inputs: Pc_Dl_Req_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`系统要求`)
};

/**
* | output |
* | --- |
* | "System requirements" |
*
* @param {Pc_Dl_Req_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_req_title = /** @type {((inputs?: Pc_Dl_Req_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Req_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_req_title(inputs)
	return zh_pc_dl_req_title(inputs)
});
export { pc_dl_req_title as "pc.dl.req_title" }